import { PdApiActions, PdApiActionsEnum } from "../actions/pdApiActions";
import { isLoadingInitialState } from "./initialState";

const loadingReducer = (
  state: State.LoadingStatus = isLoadingInitialState,
  action: PdApiActions
): State.LoadingStatus => {
  switch (action.type) {
    case PdApiActionsEnum.SET_LOADING_PARAMETERS: {
      const loading = action.payload;
      return { ...state, isLoadingParameters: loading };
    }
    case PdApiActionsEnum.ESCALATOR_PARAMETERS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEscalatorParameters: loading };
    }
    case PdApiActionsEnum.APM_PARAMETERS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingApmParameters: loading };
    }
    case PdApiActionsEnum.APM_FAULTS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingApmFaults: loading };
    }
    case PdApiActionsEnum.SIGNALIZATION_FAULTS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingSignalizationFaults: loading };
    }
    case PdApiActionsEnum.DRIVE_FAULTS_LOADING: {
      const loading = action.payload;
      return { ...state, isDriveFaultsLoading: loading };
    }
    case PdApiActionsEnum.DRIVE_PARAMETERS_LOADING: {
      const loading = action.payload;
      return { ...state, isDriveParametersLoading: loading };
    }
    case PdApiActionsEnum.LIFT_FAULTS_LOADING: {
      const loading = action.payload;
      return { ...state, isLiftFaultsLoading: loading };
    }
    case PdApiActionsEnum.GROUP_FAULTS_LOADING: {
      const loading = action.payload;
      return { ...state, isGroupFaultsLoading: loading };
    }
    case PdApiActionsEnum.NETWORK_FAULTS_LOADING: {
      const loading = action.payload;
      return { ...state, isNetworkFaultsLoading: loading };
    }
    case PdApiActionsEnum.MONITORING_FAULTS_LOADING: {
      const loading = action.payload;
      return { ...state, isMonitoringFaultsLoading: loading };
    }
    case PdApiActionsEnum.MONITORING_FAULT_CATEGORIES_LOADING: {
      const loading = action.payload;
      return { ...state, isMonitoringFaultCategoriesLoading: loading };
    }
    case PdApiActionsEnum.DOOR_BINDINGS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingDoorBindings: loading };
    }
    case PdApiActionsEnum.ESCALATOR_VERSIONS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEscalatorVersions: loading };
    }
    case PdApiActionsEnum.SET_LOADING_FAULTS: {
      const loading = action.payload;
      return { ...state, isLoadingFaults: loading };
    }
    case PdApiActionsEnum.ESCALATOR_FAULT_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEscalatorFaults: loading };
    }
    case PdApiActionsEnum.ESCALATOR_EVENT_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEventEnumerations: loading };
    }
    case PdApiActionsEnum.DOOR_EVENT_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEventEnumerations: loading };
    }
    case PdApiActionsEnum.SET_LOADING_STATISTICS: {
      const loading = action.payload;
      return { ...state, isLoadingStatistics: loading };
    }
    case PdApiActionsEnum.TRANSLATION_LOG_ITEMS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingTranslationLog: loading };
    }
    case PdApiActionsEnum.ESCALATOR_RTDS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEscalatorRTDs: loading };
    }
    case PdApiActionsEnum.ESCALATOR_RTD_GROUPS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEscalatorRTDGroups: loading };
    }
    case PdApiActionsEnum.DATAACT_CODE_LOADING: {
      const loading = action.payload;
      return { ...state, isDataActCodesLoading: loading };
    }
    case PdApiActionsEnum.ESCALATOR_DATAACT_CODE_LOADING: {
      const loading = action.payload;
      return { ...state, isEscalatorDataActCodesLoading: loading };
    }
    case PdApiActionsEnum.GRAND_NORMS_LOADING: {
      const loading = action.payload;
      return { ...state, isGrandNormsLoading: loading };
    }
    case PdApiActionsEnum.ESCALATOR_EVENT_LOGS_LOADING: {
      const loading = action.payload;
      return { ...state, isLoadingEscalatorEventLogs: loading };
    }
    default:
      return state;
  }
};

export default loadingReducer;
